/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Page_Finishing_LabelInputs */

const en_login_page_finishing_label = /** @type {(inputs: Login_Page_Finishing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparing your Glider account…`)
};

const de_login_page_finishing_label = /** @type {(inputs: Login_Page_Finishing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihr Glider-Konto wird vorbereitet…`)
};

const pt_br2_login_page_finishing_label = /** @type {(inputs: Login_Page_Finishing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparando sua conta Glider…`)
};

const tr_login_page_finishing_label = /** @type {(inputs: Login_Page_Finishing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glider hesabınız hazırlanıyor…`)
};

const zh_cn2_login_page_finishing_label = /** @type {(inputs: Login_Page_Finishing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在准备您的 Glider 账户…`)
};

const zh_hk2_login_page_finishing_label = /** @type {(inputs: Login_Page_Finishing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在準備你的 Glider 帳戶…`)
};

const ko_kr2_login_page_finishing_label = /** @type {(inputs: Login_Page_Finishing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glider 계정 준비 중…`)
};

const ru_ru2_login_page_finishing_label = /** @type {(inputs: Login_Page_Finishing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подготавливаем ваш аккаунт Glider…`)
};

const es_419_login_page_finishing_label = /** @type {(inputs: Login_Page_Finishing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparando tu cuenta de Glider…`)
};

/**
* | output |
* | --- |
* | "Preparing your Glider account…" |
*
* @param {Login_Page_Finishing_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const login_page_finishing_label = /** @type {((inputs?: Login_Page_Finishing_LabelInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Page_Finishing_LabelInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_login_page_finishing_label(inputs)
	if (locale === "de") return de_login_page_finishing_label(inputs)
	if (locale === "pt-BR") return pt_br2_login_page_finishing_label(inputs)
	if (locale === "tr") return tr_login_page_finishing_label(inputs)
	if (locale === "zh-CN") return zh_cn2_login_page_finishing_label(inputs)
	if (locale === "zh-HK") return zh_hk2_login_page_finishing_label(inputs)
	if (locale === "ko-KR") return ko_kr2_login_page_finishing_label(inputs)
	if (locale === "ru-RU") return ru_ru2_login_page_finishing_label(inputs)
	return es_419_login_page_finishing_label(inputs)
});